import { memo, useState } from 'react';

import { cn } from '../../lib/styles';

interface NumberedInputProps {
  number?: number;
  caption?: React.ReactNode;
  children?: React.ReactNode;
}

const NumberedInputBase = ({ number, caption, children }: NumberedInputProps) => {
  const [focused, setFocused] = useState(false);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  const hasNumber = typeof number !== 'undefined';

  return (
    <div
      onFocus={handleFocus}
      onBlur={handleBlur}
      className={cn(
        'flex p-2 rounded-sm gap-3',
        'bg-bg-inter-secondary-default outline-1 outline-bg-inter-secondary-default focus-visible:outline-border-input-select transition-all',
        { 'outline-border-input-select': focused },
      )}
    >
      {hasNumber ? (
        <>
          <div className="w-4 px-2 grid place-items-center font-body-md font-semibold">{number}</div>

          <div className="min-h-4 w-px bg-border-secondary" />
        </>
      ) : null}

      <div
        className={cn('flex flex-col gap-2 w-full', {
          'py-2': !!caption,
          'px-2': !hasNumber,
        })}
      >
        {caption ? <div className="font-body-sm text-text-tertiary font-semibold">{caption}</div> : null}

        <div className="[&_*]:font-body-md [&_*]:text-text-primary">{children}</div>
      </div>
    </div>
  );
};

export const NumberedInput = memo(NumberedInputBase);
